import React, { Component } from 'react';
import MainSettingContext from './MainSettingContext';
import { t } from './i18n';

class Rebate extends Component {
    static contextType = MainSettingContext;
    constructor(props) {
        super(props)
        this.state = {
            loginstate: props.loginstate || false,
            username: props.username || "",
            userid: props.userid || null,
            tblprofile: props.tblprofile || null,
            balance: props.balance || 0,
            point: props.point || 0,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tblprofile !== this.props.tblprofile) {
            this.setState({ tblprofile: this.props.tblprofile });
        }
    }

    render() {
        const lang = this.props.language || this.context?.language || 'th';
        return (
            <>
                <div className="container p-0 x-margin-top-v3">
                    <div className="row m-0 border-shadow-title">
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web" style={{ paddingTop: 50 }}>
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" href="/event">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="currentColor" className="bi bi-arrow-left-circle text-white" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>{t(lang, 'rebate_title')}</h5>
                                            </div>
                                            <div>{/**/}</div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>

                            <div className="p-2 bg-profile-box-overview animated animatedFadeInUp fadeInUp">
                                <div className="text-center py-5">
                                    <p className="text-white-v1" style={{ opacity: 0.6 }}>{t(lang, 'coming_soon')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Rebate;
